// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lx-editable-cell .ag-cell-wrapper .ag-cell-value .permalink__not-set{text-decoration:underline}.wordpress-enabled{display:flex;justify-content:center !important}.wordpress-enabled .ag-header-cell-text{text-align:center;display:block;width:100%}.no-value .ag-cell-value{text-decoration:none !important;opacity:.5;color:#6c757d}.site-order .ag-cell-wrapper{justify-content:center !important}", ""]);
// Exports
module.exports = exports;
